import {
  GoogleLoginProvider,
  GoogleSigninButtonModule,
} from "@abacritt/angularx-social-login";
import { Component, EventEmitter, Output } from "@angular/core";
import { AppleLoginButtonComponent } from "./apple-login-button/apple-login-button.component";
import { GoogleLoginButtonComponent } from "./google-login-button/google-login-button.component";

@Component({
    selector: "app-social-login",
    imports: [
        GoogleLoginButtonComponent,
        AppleLoginButtonComponent,
        GoogleSigninButtonModule,
    ],
    templateUrl: "./social-login.component.html",
    styleUrl: "./social-login.component.scss"
})
export class SocialLoginComponent {
  @Output() loginWithSocialMedia = new EventEmitter<string>();
  // A Apple não passa pela lib ngx-social-login — fluxo próprio tratado no modal.
  @Output() loginWithApple = new EventEmitter<void>();

  loginWithGoogle() {
    this.loginWithSocialMedia.emit(GoogleLoginProvider.PROVIDER_ID);
  }

  onLoginWithApple() {
    this.loginWithApple.emit();
  }
}
